<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="login">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email" required></v-text-field>

            <v-layout row wrap align-center ml-2 pr-2>
               <v-layout justify-center column align-start mb-0>
                  <router-link class="text-button" to="/">Return to Sign In</router-link>
                <router-link to="/send-confirm-code" class="text-button">Still unable to login?</router-link>
               </v-layout>
              <v-spacer />
             <button type="submit" class="button" :disabled="!valid" color="success">Send Code</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ForgotPasswordForm',
  data () {
    
    return {
      valid: true,
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      username: '',
      error: null,
      success: null,
      loading: false
    }
  },
  mounted (){
    
    // check for query string params to populate
    var search = location.search.substring(1);
    if (search) {
      var parameters = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
      //alert(parameters)
      console.log('PARAMS', parameters)
      if(parameters.email){
        this.username = decodeURIComponent(parameters.email).replace(' ','+')
      }
    }

  },
  methods: {
    login(e) {
        e.preventDefault()
        this.loading = true
        var email = this.username

        this.$forgotPassword(email).subscribe((data) => {
            console.log('forgot password request success');
            this.$router.push("/reset-password");
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.error = err
            if(this.error.message == "1 validation error detected: Value at 'username' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+"){
              this.error.message = 'Please ensure that your email address is valid (and does not contain any spaces or illegal characters).'
            }

            if(err.code === "UnknownError"){
                this.$router.push("/login-set-password");
            }
        this.emailVerificationMessage = true;
        });

    }
  }
}
</script>

<style scoped>
</style>